import {AiOutlineCheckCircle, AiOutlineCloseCircle} from "react-icons/ai";
import {NeoDescription} from "../shared";

export const SuccessfulModal = ({
  success,
  message
}: {
  success: boolean;
  message: string;
}) => {
  return (
    <div className="flex flex-col items-center gap-4 pt-4">
      {success ? (
        <AiOutlineCheckCircle className="text-green-600" size={52} />
      ) : (
        <AiOutlineCloseCircle className="text-red-600" size={52} />
      )}

      <NeoDescription message={message} />
    </div>
  );
};
